import {
  Container,
  Button,
  Header,
  Input,
  FormField,
  SpaceBetween
} from '@cloudscape-design/components';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../context/authContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export const ChangePassword = () => {
  const { auth } = useContext(UserContext);
  const [first, setFirst] = useState<string>('');
  const [second, setSecond] = useState<string>('');
  const [old, setOld] = useState<string>('');
  const [showSave, setShowSave] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate()

  const updatePassword = async () => {
    setIsLoading(true)
    const result = await axios.put(
      `${process.env.REACT_APP_API}/changepassword`,
      { oldpassword: old, newpassword: first },
      auth
    );
    if(result.status === 204) {
      setIsLoading(false);
      navigate('/app/landing')
    }
  };
  useEffect(() => {
    if (first === second && (first !== '' || second !== '' || old !== '')) {
      setShowSave(true);
    } else {
      setShowSave(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [first, second]);
  return (
    <Container
      header={
        <Header
          actions={
            <Button 
            onClick={() => updatePassword()}
             disabled={!showSave}
             loading={isLoading}
             >
              save
            </Button>
          }
        >
          Change Password
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        <FormField label="Old password">
          <Input
            type="password"
            value={old}
            onChange={(event) => setOld(event.detail.value)}
          />
        </FormField>
        <FormField>
          <Input
            type="password"
            value={first}
            onChange={(event) => setFirst(event.detail.value)}
          />
        </FormField>
        <FormField>
          <Input
            type="password"
            value={second}
            onChange={(event) => setSecond(event.detail.value)}
          />
        </FormField>
      </SpaceBetween>
      
    </Container>
  );
};
